import { initializeApp } from 'firebase/app'
import { getFirestore } from '@firebase/firestore'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_BUCKET,
    messagingSenderId: process.env.REACT_APP_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)

export const analytics = getAnalytics(app)
export const firestore = getFirestore(app)

// Defer Performance SDK — it's analytics-only, zero UX impact
const initPerf = () => {
    import('firebase/performance').then(({ getPerformance }) => {
        getPerformance(app)
    })
}
if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(initPerf)
} else {
    setTimeout(initPerf, 3000)
}
export const perf = null // kept for any existing import compatibility
